var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.253 8.801a.6.6 0 010 .849L13.13 14.77a1.6 1.6 0 01-2.263 0L5.75 9.651a.6.6 0 11.849-.848l5.119 5.12a.4.4 0 00.566 0L17.404 8.8a.6.6 0 01.849 0z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGxSdWxlPSJldmVub2RkIiBjbGlwUnVsZT0iZXZlbm9kZCIgZD0iTTE4LjI1MjUgOC44MDEyMkMxOC40ODY4IDkuMDM1NTQgMTguNDg2OCA5LjQxNTQ0IDE4LjI1MjUgOS42NDk3NUwxMy4xMzEyIDE0Ljc3MTFDMTIuNTA2MyAxNS4zOTU5IDExLjQ5MzMgMTUuMzk1OSAxMC44Njg0IDE0Ljc3MTFMNS43NDg5OCA5LjY1MTYyQzUuNTE0NjYgOS40MTczMSA1LjUxNDY2IDkuMDM3NDEgNS43NDg5OCA4LjgwMzA5QzUuOTgzMjkgOC41Njg3OCA2LjM2MzE5IDguNTY4NzggNi41OTc1MSA4LjgwMzA5TDExLjcxNyAxMy45MjI1QzExLjg3MzIgMTQuMDc4OCAxMi4xMjY0IDE0LjA3ODggMTIuMjgyNiAxMy45MjI1TDE3LjQwNCA4LjgwMTIyQzE3LjYzODMgOC41NjY5MSAxOC4wMTgyIDguNTY2OTEgMTguMjUyNSA4LjgwMTIyWiIgZmlsbD0iY3VycmVudENvbG9yIiAvPgo8L3N2Zz4=";
export { SvgDownChevron as ReactComponent };